import {useEffect, useId, useState} from "react";
import {CheckIcon, ThinCloseIcon} from "../../../components/icons/material-icons";
import {schoolClassInterface} from "../center/add-edit-center-class";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowSnackbar} from "../../../components/template/snackbar";

export const AdminsAddEditNewsModal = (props: {
    active: boolean,
    closeHandler: any,
    isEdit: boolean,
    onDone: any,
    newsId: string,
}) => {
    const [title, setTitle] = useState('');
    const [body, setBody] = useState('');
    const [category, setCategory] = useState('');
    const [isForAll, setIsForAll] = useState(true);
    const [classes, setClasses] = useState([] as schoolClassInterface[]);
    const [hasSignup, setHasSignup] = useState(false);
    const ids = {
        title: useId(),
        body: useId(),
        category: useId(),
    };
    const [err, setErr] = useState({
        title: false,
        body: false,
        category: false,
    });
    const getDataForEdit = (classList:schoolClassInterface[]) => {
        const _newsId = props.newsId;
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/news/get',
            {
                id:_newsId,
            },
            true,
            (d: {
                result:string,
                reason:string,
                title:string,
                body:string,
                category:string,
                isForAll:0|1,
                classes:{id:number,name:string}[] | null,
                hasSignup:0|1,
            })=>{
                HideProgressLoading();
                if(d.result !== 'OK'){
                    if(d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setTitle(d.title);
                setBody(d.body);
                setCategory(d.category);
                setIsForAll(d.isForAll === 1);
                setHasSignup(d.hasSignup === 1);
                let lst = [...classList];
                const activeList = d.classes === null ? [] : d.classes;
                activeList.forEach(a=>{
                   const i = lst.findIndex(r => r.id === a.id);
                   if(i > -1)
                       lst[i].selected = true;
                });
                setClasses(lst);
            },
            ()=>{},
            AuthRedirectAdmins,
        ).then(void 0);
    };
    const fetchClasses = (isEdit:boolean) => {
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/center/class/get-school-classes',
            {},
            true,
            (d: {
                result: string,
                reason: string | undefined,
                list: schoolClassInterface[] | null,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                let lst: schoolClassInterface[] = d.list === null ? [] : d.list;
                if(isEdit){
                    getDataForEdit(lst);
                } else {
                    setClasses(lst);
                }
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        const isActive = props.active;
        const isEdit = props.isEdit;
        if (isActive) {
            setTitle('');
            setBody('');
            setCategory('');
            setIsForAll(true);
            setHasSignup(false);
            setErr({
                body: false,
                title: false,
                category: false,
            });
            fetchClasses(isEdit);
            document.body.classList.add("body-no-scroll");
        } else {
            document.body.classList.remove('body-no-scroll')
        }
    }, [props.active]);
    const saveChanges = () => {
        const _title = title.trim();
        const _category = category.trim();
        const _body = body.trim();
        const _isForAll = isForAll ? '1' : '0';
        const _signup = hasSignup ? '1' : '0';
        const _isEdit = props.isEdit;
        const newsId = props.newsId;
        const _classes = [...classes];
        let lst:number[] = [];
        _classes.forEach(c=>{
            if(c.selected)
                lst.push(c.id);
        });
        let errors = {
            title: false,
            body: false,
            category: false,
        };
        let stop = false;
        if(_title.length < 2){
            stop = true;
            errors.title = true;
        }
        if(_body.length < 2){
            stop = true;
            errors.body = true;
        }
        if(_category.length < 2){
            stop = true;
            errors.category = true;
        }
        setErr({...errors});
        if(stop)
            return;
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/news/' + (_isEdit ? 'edit':'add'),
            {
                id:newsId.toString(),
                title:_title,
                body:_body,
                category:_category,
                classes:JSON.stringify(lst),
                isForAll:_isForAll,
                hasSignup:_signup,
            },
            true,
            (d: {
                result:string,
                reason:string,
            })=>{
                HideProgressLoading();
                if(d.result !== 'OK'){
                    if(d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                ShowSnackbar(
                    _isEdit ? 'ویرایش اطلاعیه انجام شد.' : 'اطلاعیه جدید اضافه شد.',
                    'باشه',
                    5000,
                );
                props.closeHandler();
                props.onDone();
            },
            ()=>{},
            AuthRedirectAdmins,
        ).then(void 0);
    };
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active' : '') + (!isForAll ? ' web-modal-xl' : '')}
                 style={{top: 20}}>
                <div className="web-modal-header">
                    <div><b>{props.isEdit ? 'ویرایش اطلاعیه' : 'افزودن اطلاعیه'}</b></div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="container">
                        <div className="row add-student">
                            <div className={"col-lg-" + (isForAll ? '12' : '6')}>
                                <label htmlFor={ids.title}>عنوان اطلاعیه:</label>
                                <input type="text"
                                       className={"form-control" + (err.title ? ' is-invalid' : '')}
                                       value={title}
                                       onChange={e => {
                                           const t = e.currentTarget.value;
                                           setTitle(t);
                                           setErr(v => {
                                               let x = {...v};
                                               x.title = false;
                                               return x;
                                           });
                                       }}
                                       id={ids.title}
                                />
                                <div className={"invalid-feedback " + (err.title ? 'd-block' : 'd-none')}>
                                    لطفا حداقل ۲ کاراکتر وارد کنید.
                                </div>
                                <div style={{height: 20}}/>
                                <label htmlFor={ids.category}>دسته‌بندی:</label>
                                <input type="text"
                                       className={"form-control" + (err.category ? ' is-invalid' : '')}
                                       id={ids.category}
                                       value={category}
                                       onChange={e => {
                                           const t = e.currentTarget.value;
                                           setCategory(t);
                                           setErr(v => {
                                               let x = {...v};
                                               x.category = false;
                                               return x;
                                           });
                                       }}
                                />
                                <div className={"invalid-feedback " + (err.category ? 'd-block' : 'd-none')}>
                                    لطفا حداقل ۲ کاراکتر وارد کنید.
                                </div>
                                <div style={{height: 20}}/>
                                <label htmlFor={ids.body}>متن اطلاعیه:</label>
                                <textarea id={ids.body}
                                          className={"form-control" + (err.body ? ' is-invalid' : '')}
                                          value={body}
                                          onChange={e => {
                                              const t = e.currentTarget.value;
                                              setBody(t);
                                              setErr(v => {
                                                  let x = {...v};
                                                  x.body = false;
                                                  return x;
                                              });
                                          }}
                                          style={{minHeight: 150}}
                                />
                                <div className={"invalid-feedback " + (err.body ? 'd-block' : 'd-none')}>
                                    لطفا حداقل ۲ کاراکتر وارد کنید.
                                </div>
                                <div style={{height: 20}}/>
                                <button className={"techaran-switch" + (hasSignup ? ' active' : '')}
                                        onClick={() => setHasSignup(v => !v)}>
                                    <i><b/></i>
                                    <span>
                                        {hasSignup ? 'دارای ثبت‌نام' : 'بدون ثبت‌نام'}
                                        <em>گزینه ثبت‌نام در پایان اطلاعیه.</em>
                                    </span>
                                </button>
                                <button className={"techaran-switch" + (isForAll ? ' active' : '')}
                                        onClick={() => setIsForAll(v => !v)}>
                                    <i><b/></i>
                                    <span>
                                        {isForAll ? 'همگانی' : 'کلاس‌های خاص'}
                                        <em>نوع نمایش اطلاعیه به دانش‌آموزان.</em>
                                    </span>
                                </button>
                                <div style={{height: 20}}/>
                            </div>
                            {
                                !isForAll ?
                                    <div className={"col-lg-6"}>
                                        <label style={{display: 'block'}}>کلاس‌های هدف:</label>
                                        {
                                            classes.map((c, i) =>
                                                <button key={"Az39r3578FF23" + i}
                                                        style={{width: '50%', display: 'inline-flex'}}
                                                        className={"techaran-checkbox" + (c.selected ? ' active' : '')}
                                                        onClick={() => setClasses(v => {
                                                            let x = [...v];
                                                            x[i].selected = !x[i].selected;
                                                            return x;
                                                        })}>
                                                    <i><CheckIcon/></i>
                                                    <span>{c.title}</span>
                                                </button>
                                            )
                                        }
                                        <div style={{height: 20}}/>
                                    </div> : null
                            }
                        </div>
                        <div className="d-flex justify-content-end align-items-center" style={{gap:10}}>
                            <button className="cancel-button" onClick={props.closeHandler}>
                                <b>انصراف</b>
                            </button>
                            <button className="btn-pay" onClick={saveChanges}>
                                <b>ذخیره</b>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};